"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginView = exports.changeLanguage = exports.getErrorByField = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var connected_react_router_1 = require("connected-react-router");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var authActions = require("@caddigital/sok-reducers/lib/actions/auth/login");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var LoginContainer_1 = require("containers/LoginContainer");
var translate_1 = require("utils/translate");
var languages_1 = require("utils/helpers/languages");
var LanguageSelectorDropdown_1 = require("components/LanguageSelectorDropdown");
var Icon_1 = require("components/Icon");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var language = languages_1.languageData.find(function (x) { return selectedLanguage === x.code; });
    return {
        email: state.auth.login.email,
        password: state.auth.login.password,
        isLogin: state.auth.login.status,
        errors: state.auth.login.errors,
        federated: state.auth.login.isFederated,
        provider: state.auth.login.provider,
        translations: state.translations,
        selectedLanguage: selectedLanguage,
        language: language
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    onLogin: function (username, password) {
        dispatch(authActions.loginRequestAction(username, password));
    },
    setEmail: function (email) {
        dispatch(authActions.setEmailAction(email.trim().toLowerCase()));
    },
    setPassword: function (password) {
        dispatch(authActions.setPasswordAction(password.trim()));
    },
    redirect: function () { return dispatch((0, connected_react_router_1.replace)('/')); },
    isFederated: function (email) {
        var domain = /@(.*)$/.exec(email.toLowerCase());
        if (domain !== null && domain[0]) {
            dispatch(authActions.isFederated(email));
        }
    },
    redirectToSSO: function (url) { return dispatch((0, connected_react_router_1.replace)(url)); },
    fetchLanguage: function (language) {
        (0, translate_1.setLanguage)(language);
        dispatch((0, translations_1.fetchLanguageRequest)(language));
    },
    clearToasts: function () { return dispatch(toastActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps);
var getErrorByField = function (field, error) {
    if (error && error.length > 0) {
        return React.createElement("div", null, error[0]);
    }
    return undefined;
};
exports.getErrorByField = getErrorByField;
var changeLanguage = function (language, props) {
    props.history.push("/".concat(language, "/login"));
    props.fetchLanguage(language);
};
exports.changeLanguage = changeLanguage;
var LoginInfo = function () {
    var message = (0, translation_1.getLocalization)('LOGIN_INFO');
    if (message === '-' || message === 'LOGIN_INFO')
        return null;
    return React.createElement("div", { className: 'login-info' }, message);
};
exports.LoginView = enhance(/** @class */ (function (_super) {
    __extends(LoginViewComponent, _super);
    function LoginViewComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoginViewComponent.prototype.componentWillMount = function () {
        if (this.props.isLogin === 'LOGGED_IN') {
            this.props.redirect();
        }
    };
    LoginViewComponent.prototype.componentWillUnmount = function () {
        // Clear all old toasts after success login
        this.props.clearToasts();
    };
    LoginViewComponent.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isLogin === 'LOGGED_IN' &&
            this.props.isLogin !== prevProps.isLogin) {
            this.props.redirect();
        }
        if (this.props.federated &&
            this.props.federated !== prevProps.federated) {
            this.props.redirectToSSO("/sso/".concat(this.props.provider));
        }
    };
    LoginViewComponent.prototype.render = function () {
        var props = this.props;
        return (React.createElement(LoginContainer_1.LoginContainer, { bg: 4, translations: this.props.translations.translations },
            React.createElement("div", { className: 'login-panel' },
                React.createElement("form", { className: "login-form animated fadeIn", onSubmit: function (e) { return (e.preventDefault(), props.onLogin(props.email, props.password)); } },
                    props.isLogin === 'FAILED' && !props.errors && (React.createElement("div", { className: 'error login-failed' },
                        (0, translation_1.getLocalization)('userfront/Login/Placeholder/Notification/IncorrectUsernameOrPassword'),
                        "\u00A0",
                        React.createElement(Icon_1.Icon, { className: 'fa-question-circle' }))),
                    props.isLogin === 'EXPIRED' && (React.createElement("div", { className: "error login-expired" }, (0, translation_1.getLocalization)('userfront/Login/Placeholder/Notification/AuthenticationHasExpiredPleaseLoginAgain'))),
                    React.createElement(LanguageSelectorDropdown_1.default, { languageCode: props.selectedLanguage, updateUserLanguage: props.fetchLanguage }),
                    React.createElement(sok_ui_1.TextInput, { className: props.isLogin === 'FAILED' &&
                            props.errors &&
                            props.errors['email']
                            ? 'sok-input-error-border'
                            : '', placeholder: (0, translation_1.getLocalization)('userfront/Login/Placeholder/EmailAddress'), id: "email", value: props.email, onChange: function (e) {
                            props.setEmail(e.target.value);
                            props.isFederated(e.target.value);
                        }, icon: React.createElement(Icon_1.Icon, { className: "fa-user" }) }),
                    props.isLogin === 'FAILED' &&
                        props.errors &&
                        props.errors.email && (React.createElement("div", { className: 'error' }, (0, exports.getErrorByField)('email', props.errors['email']))),
                    React.createElement(sok_ui_1.TextInput, { placeholder: (0, translation_1.getLocalization)('userfront/Login/Placeholder/password'), type: "password", id: "password", className: props.isLogin === 'FAILED' &&
                            props.errors &&
                            props.errors['password']
                            ? 'sok-input-error-border'
                            : '', value: props.password, onChange: function (e) {
                            return props.setPassword(e.target.value);
                        }, icon: React.createElement(Icon_1.Icon, { className: "fa-lock" }) }),
                    props.isLogin === 'FAILED' &&
                        props.errors &&
                        props.errors.password && (React.createElement("div", { className: 'error' }, (0, exports.getErrorByField)('password', props.errors['password']))),
                    React.createElement(sok_ui_1.Button, { size: "large", color: "base-blue", id: "submit", type: 'submit', text: props.isLogin === 'LOGGING_IN' ? (React.createElement(Icon_1.Icon, { className: 'fa-spinner fa-spin' })) : ((0, translation_1.getLocalization)('userfront/Login/Placeholder/button/signIn')) }),
                    React.createElement("div", { className: ' sso-login-container-links' },
                        React.createElement("div", null,
                            React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/forgotpassword").concat(props.email
                                    ? "?email=".concat(encodeURIComponent(props.email))
                                    : '') }, (0, translation_1.getLocalization)('usefront/Login/Placeholder/ForgotYourPassword'))),
                        React.createElement("div", { className: 'sso-link-container' },
                            React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/sso") }, (0, translation_1.getLocalization)('userfront/Login/Placeholder/SingleSignOn')))),
                    React.createElement(LoginInfo, null)))));
    };
    return LoginViewComponent;
}(React.PureComponent)));
exports.default = exports.LoginView;
